import React from "react";

import { Button } from "../../../button";
import { Image } from "../../../image";
import {
    BRIDGE_FUNCTION,
    OPEN_LINK,
} from "../../../../constants/types/commands";
import { useOpenNewsArticle } from "../../../../hooks/use-open-news-article";
import { useSendCommand } from "../../../../hooks/use-send-command";

import styles from "./styles.modules.scss";

export const BlockButton = ({
    image,
    label,
    position,
    variant,
    url,
    urlType,
    functionName,
    functionArgs,
}: InboxArticleButtonBlock) => {
    const openNewsArticle = useOpenNewsArticle();
    const sendCommand = useSendCommand();

    const handleClick = () => {
        switch (urlType) {
            case "article":
                return openNewsArticle(
                    url.id,
                    label,
                    url.section === "esportNewsEntries" ? "esport" : "news",
                );
            case "bridgeFunction":
                return sendCommand(BRIDGE_FUNCTION, {
                    functionName: functionName,
                    functionArgs: functionArgs,
                });
            default:
                return sendCommand(OPEN_LINK, {
                    url,
                    label,
                });
        }
    };

    if (urlType === "article" && url?.section === "carouselEventPollEntry") {
        return null;
    }

    return (
        <div
            className={`block-button ${styles.blockButton} ${
                position !== undefined
                    ? `${styles[position]} ${position}`
                    : `${styles.left} left`
            }`}
        >
            <div className={`before ${styles.before}`} />

            {image ? (
                <div className={`image ${styles.image}`} onClick={handleClick}>
                    <Image sources={image} />
                </div>
            ) : (
                <Button onClick={handleClick} variant={variant}>
                    <div className={`buttonTextWrapper ${styles.label}`}>
                        {label}
                    </div>
                </Button>
            )}

            <div className={`after ${styles.after}`} />
        </div>
    );
};
